import { Maximize2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";

// Embeds the standalone Three.js duckbill-umbrella valve interactive (served
// as a static asset at /interactive/valve.html) inside an on-page modal, with
// a link out to its own full page for direct sharing.
export function ValveViewer({ children }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        data-testid="valve-viewer-modal"
        className="p-0 gap-0 max-w-[96vw] sm:max-w-4xl w-full h-[88vh] bg-[#0f1d36] border border-zinc-800 overflow-hidden rounded-xl"
      >
        <DialogTitle className="sr-only">Duckbill-umbrella combination valve, interactive 3D model</DialogTitle>
        <DialogDescription className="sr-only">
          Drag to rotate, scroll or pinch to zoom, and switch between closed, forward flow and
          reverse flow states.
        </DialogDescription>
        <iframe
          src="/interactive/valve.html"
          title="Duckbill-umbrella combination valve interactive 3D model"
          className="w-full h-full border-0"
          data-testid="valve-viewer-iframe"
        />
        <Link
          to="/technology/valve"
          data-testid="valve-viewer-fullpage-link"
          className="absolute left-3 bottom-3 font-mono text-[10px] tracking-[0.12em] uppercase text-white/70 bg-black/40 backdrop-blur px-3 py-1.5 rounded-full hover:text-white transition-colors flex items-center gap-1.5"
        >
          <Maximize2 size={11} />
          Open full page
        </Link>
      </DialogContent>
    </Dialog>
  );
}
